import { Component, Input, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'data-analysis-modal',
    templateUrl: 'data-analysis-modal.component.html',
    styles: [
        `
            .window-close,
            .window-close:hover {
                float: right;
                font-size: 2em;
                margin-right: 25px;
                margin-top: 13px;
                cursor: pointer;
            }

            table thead th {
                font-size: 10px;
            }

            .small {
                font-weight: normal;
            }
        `,
    ],
})
export class TrainingDataAnalysisModalComponent {
    @ViewChild('infoModal')
    private infoModal;

    private title: string;
    private data: any;
    private infoModalRef: any;

    private regions = [
        'paris',
        'lyon',
        'rennes',
        'nantes',
        'lille',
        'bordeaux',
        'autre',
        'presta',
    ];
    private regionNames = {
        paris: 'Paris',
        lyon: 'Lyon',
        rennes: 'Rennes',
        nantes: 'Nantes',
        lille: 'Lille',
        bordeaux: 'Bordeaux',
        autre: 'Sans formateur',
        presta: 'Sous traitant',
    };

    constructor(private modalService: NgbModal) {}

    private openInfoModal() {
        if (this.infoModal) {
            this.infoModalRef = this.modalService.open(this.infoModal, {
                size: 'lg',
            });
        }
    }

    private closeInfoModal() {
        this.infoModalRef.close();
    }

    display(title: string, data: any) {
        this.title = title;
        this.data = data;

        this.openInfoModal();
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/stats/data-analysis/_component/data-analysis-modal.component.ts